import { render, staticRenderFns } from "./aviso-operacion-dudosa.vue?vue&type=template&id=aed07c70&scoped=true"
import script from "./aviso-operacion-dudosa.vue?vue&type=script&lang=js"
export * from "./aviso-operacion-dudosa.vue?vue&type=script&lang=js"
import style0 from "./aviso-operacion-dudosa.vue?vue&type=style&index=0&id=aed07c70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed07c70",
  null
  
)

export default component.exports